export const unixTimestampToJs = (unixTime: number): Date => {
  const milliseconds = unixTime * 1000
  return new Date(milliseconds);
}

export const formatDate = (dateStr?: Date | string | null | undefined): string => {
  if(!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString();
}
/**
 * Convert JSON date to YYYY-MM-DD format to be used by MUI Date Picker
 * @param d
 */
export const jsToDatePicker = (d: string | undefined) => {
  if(!d) return;
  const date = new Date(d);
  if(date.toJSON() == null) return;
  return `${date.getFullYear()}-${padDate(date.getMonth()+1)}-${padDate(date.getDate())}`;
}

function padDate(n: number){
  return (n + "").padStart(2, '0');
}

export function dateToYYYMMMDDD(date?: Date | string | undefined | null): string {
  if (!date) return '';
  if (!(date instanceof Date)) {
    let [year, month, day] = date.split('-');
    if (day.includes('T')) day = day.split('T')[0];
    date = new Date(Number(year), Number(month) - 1, Number(day));
  }
  if (date.toDateString() === 'Invalid Date') return '';
  return `${startWithZero(date.getMonth() + 1)}/${startWithZero(date.getDate())}/${date.getFullYear()}`;
}

function startWithZero(d: number): string {
  return d.toString().padStart(2, '0');
}